import React, { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { useI18n } from "../i18n";
import { BRAND } from "../config/plans";
import Icon from "../components/ui/Icon";
import BrandMark from "../components/BrandMark";
import Shell from "./Shell";

export const SUPER_MENU = [
  { to: "/su", exact: true, icon: "building", label: "ร้านทั้งหมด", labelEn: "Shops" },
  { to: "/su/sales", icon: "chartBar", label: "ยอดขาย", labelEn: "Sales" },
  { to: "/su/requests", icon: "fileText", label: "คำขอ & ใบเสนอราคา", labelEn: "Requests & quotes" },
  { to: "/su/boosts", icon: "heart", label: "ออเดอร์ปั้ม", labelEn: "Boost orders" },
];

// หน้าทีมงานเจ้าของระบบ (super_user) — ใช้โครงเดียวกับหลังบ้านร้าน หน้าตาตามธีมของเว็บนี้
export default function SuperLayout() {
  const { profile, logout } = useApp();
  const { tx, lang, setLang, pick } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const current = SUPER_MENU.filter((item) => (item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to)))
    .sort((a, b) => b.to.length - a.to.length)[0];

  const groups = useMemo(
    () => [
      {
        id: "super",
        title: `${BRAND.name} · ${tx("ทีมงานเจ้าของระบบ", "Platform team")}`,
        short: "super",
        railIcon: "building",
        items: SUPER_MENU.map((item) => ({ ...item, label: pick(item, "label") })),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lang]
  );

  const langBtn = (
    <button type="button" className="lx-pill" onClick={() => setLang(lang === "th" ? "en" : "th")}>
      {lang === "th" ? "TH" : "EN"}
    </button>
  );

  return (
    <Shell
      groups={groups}
      brand={<BrandMark brand={{ shortName: "SU" }} />}
      brandTo="/su"
      title={current ? pick(current, "label") : "super_user"}
      navLabel="super_user"
      toggleLabel={tx("เปิด/ปิดเมนูย่อย", "Toggle menu panel")}
      closeLabel={tx("ปิด", "Close")}
      topRight={
        <>
          <span className="u-fs-12 u-muted lx-hide-sm">{profile?.email}</span>
          {langBtn}
          <button
            type="button"
            className="lx-pill"
            onClick={async () => {
              await logout();
              navigate("/su/login");
            }}
          >
            <Icon name="logout" /> <span className="lx-hide-sm">{tx("ออกจากระบบ", "Log out")}</span>
          </button>
        </>
      }
    >
      <Outlet />
    </Shell>
  );
}
